export class Faq
{
	faqId: number;
	faqDate: Date;
	faqSectionId: number;
}
